export default {
  lang: { en: "English", ko: "한국어", jp: '日本語', es: "Spanish", pt: "Portuguese", zhHant: '繁體中文' },
  "nav": {
    "xwallet": "XWallet",
    "overview": "Visión general",
    "howToUse": "Cómo utilizar",
    "userGuide": "Guía del usuario",
    "merchantGuide": "Guía del comerciante",
    "faq": "Preguntas más frecuentes"
  },
  "overview": {
    "xwalletNew": {
      "title": "XWallet de Pundi X",
      "subTitle": "Billetera Blockchain para todos",
      "down": "Descargar"
    },
    "ubiquitous": {
      "title": "Transacciones Blockchain Online y Offline",
      "subTitle": "La aplicación móvil XWallet conecta billeteras de activos digitales regulares con el ecosistema de pagos de Pundi X. Permite a los usuarios realizar pagos fácilmente en tiendas físicas a través de XPOS. La XWallet también se puede emparejar con la XPASS, lo que la convierte en una aplicación de pago digital que se puede usar en cualquier momento y en cualquier lugar.",
      list1: "Compre y gaste criptoactivos al instante a través de XPOS®️",
      list2: "Envíe y reciba cripto activos fácilmente de sus amigos y familiares en Telegram mediante XWallet. Sin cargos.",
      list3: "Acceda a una amplia gama de servicios disponibles nediante DApps en XWallet"
    },
    "integration": {
      "title": "Integración perfecta",
      "subTitle": "Puede administrar fácilmente sus activos digitales, consultar su saldo actual o recargar en XWallet. De forma predeterminada, cada usuario tendrá una tarjeta virtual XPASS en la aplicación. También puede vincular su XWallet con su tarjeta Pundi XPASS para realizar pagos directamente desde la aplicación cuando sea necesario. Si pierde la tarjeta XPASS, puede transferir todas sus fichas de la tarjeta XPASS a la aplicación XWallet o a otra tarjeta XPASS.",
      "wallet": {
        "title": "Recarga tu XWallet desde otras carteras",
        "list1": "Seleccione el ícono ‘Tarjeta’ y elija la tarjeta virtual.",
        "list2": "Seleccione el tipo de moneda que desea recargar.",
        "list3": "Toque el ícono ‘Recibir’ y elija ‘Ver dirección’.",
        "list4": "Copie la dirección de recarga o escanee el código QR.",
        "list5": "En su otra cartera, elija el tipo de criptomoneda correcto e inserte la dirección de recarga de XWallet para realizar la transferencia.",
        "note": "(Nota: la velocidad de transferencia de tokens de otras carteras a la aplicación XWallet varía según las condiciones de la red de blockchain. Para realizar transacciones de pago instantáneo en cualquier comerciante de XPOS, recomendamos que los usuarios recarguen su cuenta de XWallet desde otras carteras al menos 6 horas antes de usar la aplicación)"
      }
    },
    "payments": {
      "title": "Pagos instantáneos en línea o en modo fuera de línea",
      "subTitle": "Las transacciones a través de un XWallet o XPASS conectado a Internet se pueden procesar inmediatamente, mientras que las transacciones fuera de línea pueden realizarse escaneando el código QR, que luego se cargará en el blockchain. En pocas palabras, la XWallet se mantiene al día con tu ocupado estilo de vida."
    },
    "security": {
      title: "Seguridad y privacidad",
      subTitle:
        "Each XWallet comes with a username and password protection feature. There is also no need for (private key) data backup because it is not a cold wallet. The app can also help users easily retrieve data stored on any phone, device, or XPASS linked to the app.",
      list1: "Soporte 2FA",
      list2: "Gestione sus billeteras privadas mediante sus claves privadas",
      list3: "Soportado acceso de seguridad biométrica"
    },
    "token": {
      "title": "Una guía de Staking NPXS / NPXSXEM para los tokens f (x)",
      "subtitle": "del 20 de marzo de 2019 al 19 de marzo de 2020",
      "linkBtn": "aprende más",
      "link": "https://medium.com/pundix/771b82266941"
    },
    "convert": {
      "title": "Una guía para convertir NPXS / NPXSXEM a tokens f(x)",
      "subtitle": "Desde 16 Abril 16 al 14 Julio, 2019",
      "linkBtn": "aprende más",
      "link": "https://medium.com/pundix/a-guide-to-converting-npxs-npxsxem-to-f-x-tokens-e1d9f3dcec77"
    },
    privateWallet: {
      title: "Soporte de múltiples billeteras privadas",
      list1: "Tome el control de sus cripto activos con opciones de billeteras privadas en XWallet",
      list2: "Las billeteras privadas incluyen: Binance Blockchain Wallet, Samsung Blockchain Wallet y Pundi X Savings mediante MEW",
      list3: "Soporte MEWConnect",
      subTitle: "Ver tutoriales",
      tutorial1: "Cómo crear una billetera de Binance Blockchain",
      tutorial2: "Cómo crear una billetera Pundi X Savings con tecnología de MEW (Android)",
      tutorial3: "Cómo restaurar una billetera MEW en XWallet (Android)"
    },
    dapps: {
      title: "DApps",
      desc: "Administre, transfiera o haga crecer sus activos digitales con las diferentes características DApps que están disponibles en XWallet",
      remark: "Comience hoy a explorar las DApps de XWallet."
    },
    telegramChat: {
      title: "Soporte Telegram",
      list1: "Chatea con tus amigos y familiares en Telegram",
      list2: "Envíe y reciba cripro activos al instante con la función \"Crypto Gift\"",
      tutorial1: "Cómo conectarse con a su cuenta Telegram mediante XWallet.",
      tutorial2: "Cómo enviar Crypto Gift",
      tutorial3: "Cómo recibir Crypto Gift."
    },
    manageAssets: {
      title: "Administre y haga crecer sus cripto activos fácilmente.",
      list1: "Empareje su tarjeta XPASS con XWallet para permitir una mejor gestión de sus cripto activos",
      list2: "Mueva sus cripto activos sin problemas entre diferentes tarjetas XPASS",
      list3: "Envíe y reciba cripto activos instantáneamente entre usuarios de XWallet sin tarifas",
      list4: "Aumente sus cripto activos mediante las diferentes Dapps y características en XWallet",
      subTitle: 'Ver el tutorial',
      tutorial1: "Cómo transferir sus cripto activos dentro de XWallet"
    }
  },
  "howToUse": {
    "title": "Cómo utilizar",
    "subTitle": "XWallet de Pundi X",
    "sect1": {
      "title": "Cómo recargar tu XWallet",
      "htuArr1": {
        "title": "Transfiriendo sus activos digitales a la XWallet",
        "li1": "1. Toque en \"Tarjeta\" \"y seleccione la tarjeta virtual.",
        "li2": "2. Seleccione el tipo de moneda que desea recargar.",
        "li3": "3. Toque el icono \"Recibir\" y seleccione \"Ver dirección\".",
        "li4": "4. Copie la dirección de recarga o escanee el código QR.",
        "li5": "5. En su otra cartera, elija el tipo de criptomoneda correcto e inserte la dirección de recarga de XWallet para realizar la transferencia."
      },
      "htuArr2": {
        "title": "Transferencia de tokens desde su tarjeta XPASS a XWallet",
        "li1": "1. Agregue su tarjeta XPASS a la aplicación XWallet.",
        "li2": "2. Toque la tarjeta XPASS de la que desea transferir los tokens.",
        "li3": "3. Elija el tipo de moneda que desea transferir a XWallet.",
        "li4": "4. Toque el icono \"...\" en la parte superior derecha y seleccione \"Transferencia interna\".",
        "li5": "5. Seleccione la tarjeta XPASS de la que desea transferir los tokens.",
        "li6": "6. Ingrese la cantidad de tokens y haga clic en el botón \"confirmar\"."
      }
    },
    "sect2": {
      "title": "Cómo transferir tokens desde tu XWallet a una dirección externa",
      "li1": "1. Elija la tarjeta de la que desea transferir los tokens.",
      "li2": "2. Seleccione el tipo de moneda que desea transferir.",
      "li3": "3. Toque en el ícono ‘Transfer’ e ingrese la dirección del receptor. Por favor, vuelva a verificar que las transacciones no pueden revertirse debido a la inmutabilidad de la cadena de bloques.",
      "li4": "4. Pulse \"Siguiente\" para completar la transacción."
    }
  },
  "userGuide": {
    "title": "Guía de usuario XWallet",
    "subTitle": "XWallet by Pundi X",
    "sect1": {
      "title": "1. ¿Qué es una Tarjeta Virtual en XWallet?",
      "desc": "Cada usuario de XWallet tiene una cuenta de tarjeta virtual original que no está vinculada a ninguna tarjeta física, como una cuenta de saldo personal de XWallet. Si tiene una tarjeta física XPASS, puede agregarla a XWallet tocando el ícono \"+\" en la parte superior izquierda de esta página.",
      "imgAlt": "Tarjeta Virtual de su cuenta Pundi X"
    },
    "sect2": {
      "title": "2. Cómo pagar monedas a la cuenta XWallet del comerciante:",
      "li1": "Haga clic en \"Escanear\" en la página de inicio del usuario",
      "li2": "Escanee el código QR de la Recibir que pertenece al comerciante.",
      "li3": "Ingrese la cantidad que correspondiente de USDT (1 USDT = 1 USD)",
      "li4": "Elija una tarjeta y la moneda correcta que tenga suficiente saldo.",
      "imgAlt1": "Pagando a comerciante",
      "imgAlt2": "Pago con éxito"
    },
    "sect3": {
      "title": "3. Cómo pagar con monedas a la cuenta XPOS del comerciante:",
      "li1": "Haga clic en \"Pagar\" en la página de inicio del usuario.",
      "li2": "Mostrar el código QR de pago del usuario al comerciante para que él / ella pueda escanear el código para completar la transacción",
      "li3": "El comerciante establecerá el sistema de recibo de acuerdo con la criptomoneda que elija en su página de código de pago",
      "li4": "Si el saldo es insuficiente, deberá pagar en otro tipo de monedas.",
      "imgAlt": "Mostrar código de pago"
    },
    "sect4": {
      "title": "4. ¿Cómo solicitar un reembolso a los comerciantes?",
      "li1": "¿No está satisfecho con su mercancía comprada y desea obtener un reembolso del comerciante? Se recomienda que se ponga en contacto con el comerciante para solicitar un reembolso lo antes posible. La solicitud de reembolso dependerá de la política de reembolso del comerciante.",
      "li2": "Si se inicia una solicitud de reembolso dentro de los 30 minutos posteriores a la transacción, el comerciante podrá completar la solicitud de reembolso en XWallet.",
      "li3": "Tenga en cuenta que el sistema actual solo admite reembolsos dentro de los 30 minutos posteriores a la transacción. Si se realiza una solicitud de reembolso después de 30 minutos, comuníquese con el comerciante para un proceso de reembolso manual, ya que no se puede realizar a través de XWallet.",
      "imgAlt1": "Encontrar transacción de reembolso",
      "imgAlt2": "Detalles de reembolso satisfactorio"
    },
    "sect5": {
      "title": "5. ¿Cómo utilizar la función “Recibir” de XWallet?",
      "li1": "La transferencia de fondos entre cuentas de XWallet se puede completar tocando el ícono “Recibir”.",
      "li2": "Toque “Recibir” en la página de inicio y guarde el código de recibir, luego otros usuarios pueden transferirle criptografía usando este código.",
      "li3": "Nota: la transferencia entre cuentas de XWallet se completa instantáneamente sin cargo por transferencia.",
      "imgAlt1": "Página personal de recibir",
      "imgAlt2": "Código personal de recibir"
    },
    "sect6": {
      "title": "6. ¿Cómo transferir de una cuenta XWallet a otra dirección de billetera / exchange",
      "li1": "Pulse \"Transferir\" en la página de inicio",
      "li2": "Elija una moneda para el pago",
      "li3": "Ingrese una dirección del beneficiario y la cantidad a transferir",
      "li4": "Confirme la transferencia",
      "li5": "Después de la transferencia, espere la confirmación en la red de blockchain para asegurarse de que se haya realizado el pago.",
      "note": "Nota: introduzca una dirección válida sin errores durante la transferencia. Crypto no se puede recuperar una vez que se realiza la transacción debido a la inmutabilidad de las transacciones de cadena de bloques.",
      "imgAlt": "Tranferencia NPXS"
    },
    "sect7": {
      "title": "7. ¿Cómo recibir / depositar criptomonedas en XWallet?",
      "li1": "Seleccione el tipo de criptomoneda que desea recibir / depositar.",
      "li2": "Toca \"Recibir\" y elige \"Ver dirección\".",
      "li3": "Copie la dirección de recepción o escanee el código QR.",
      "imgAlt1": "Cuenta NPXS",
      "imgAlt2": "NPXS dirección de recibir"
    },
    "sect8": {
      "title": "8. ¿Cómo recibir tokens XWallet Extra?",
      "desc": "XWallet actualizará las tareas en la página \"Extra\" de vez en cuando, para que los usuarios puedan recibir información sobre las características, actualizaciones e hitos de los proyectos de Pundi X, simplemente completando tareas y obteniendo tokens criptográficos. Para obtener más información, vaya a la página \"Extra\" y consulte las guías sobre tareas de token.",
      "imgAlt": "Extra página"
    },
    "sect9": {
      "title": "9. ¿Cómo retirar los tokens recibidos?",
      "li1": "Las monedas en BTC, ETH, NPXS y otras monedas criptográficas se pueden retirar solo si la cantidad de fichas alcanza el límite de retiro designado",
      "li2": "La extracción de tokens en BTC, ETH, NPXS u otras criptomonedas se transferirá automáticamente a la cuenta de la Tarjeta virtual.",
      "imgAlt": "NPXS extra de retiro"
    },
    "sect10": {
      "title": "10. ¿Cómo utilizar el vale XWallet?",
      "desc": "XWallet distribuye cupones a los usuarios de vez en cuando. Puede consultar los vales recibidos en \"Mis vales\" en la sección Extra; Los vales se pueden utilizar para pagar descuentos a los comerciantes de XWallet; Solo 1 cupón por pedido.",
      "imgAlt1": "Mis cupones",
      "imgAlt2": "Uso cupón"
    },
    "sect11": {
      "title": "11. ¿Cómo cambiar o recuperar las contraseñas de XWallet?",
      "li1": "Ir a \"Yo\" en la página de inicio",
      "li2": "Luego vaya a \"Configuración\" - \"Seguridad\"",
      "li3": "Haga clic en \"Cambiar contraseña de inicio de sesión\" o \"Cambiar contraseña de pago\"",
      "li4": "Las contraseñas también se pueden recuperar si se olvidan.",
      "imgAlt1": "Página \"YO\"",
      "imgAlt2": "Página segurida de la cuenta"
    },
    "sect12": {"title": "12. Soporte XWallet", "email": "Email：xwallet@pundix.com"}
  },
  "merchantGuide": {
    "title": "Guía Comerciante XWallet",
    "subTitle": "XWallet by Pundi X",
    "sect1": {
      "title": "1. ¿Cómo solicitar ser un comerciante de XWallet?",
      "p1": "El procedimiento de solicitud está disponible aquí:"
    },
    "sect2": {
      "title": "2. ¿Cómo hacer recaudación como comerciante?",
      "p1": "Envíe una solicitud de Comerciante XWallet, y una vez que se apruebe la solicitud, su página de \"Recibos\" se marcará con \"Pundi X Comerciante Verificado\";",
      "p2": "Puede abrir la aplicación XWallet y luego mostrar el código QR en la página \"Recibir\" para que los clientes puedan escanear y pagar;",
      "p3": "También puede tocar \"Guardar\" en la página \"Recibir\" para descargar su código QR como una imagen, imprimirlo y colocarlo junto al puesto de mostrador para que los clientes lo escaneen y paguen. Esta sería una forma más conveniente de cobrar los pagos.",
      "p4": "Los activos de criptomoneda recopilados irían directamente a la cuenta de la Tarjeta virtual del comerciante XWallet.",
      "imgAlt1": "Página de Recibir de Comerciante",
      "imgAlt2": "Imagen del código Recibir"
    },
    "sect3": {
      "title": "3. ¿Cómo establecer los pedidos para liquidar en USDT?",
      "p1": "¿Cuáles son los beneficios de usar USDT para la liquidación?",
      "p2": "Desactivar la liquidación del USDT significaría que el comerciante XWallet solo puede recopilar criptomonedas como BTC, ETH, NPXS, etc. Por lo tanto, el comerciante se vuelve propenso a la volatilidad de los precios y las fluctuaciones de las criptomonedas. La liquidación del USDT puede ayudar a Comerciantes XWallet a convertir todos los activos de criptomoneda recaudados en USDT al tipo de cambio en tiempo real. USDT es una moneda estable (1 USDT = 1 USD) que no está influenciada por cambios drásticos de precios.",
      "p3": "¿Cómo activar la liquidación del USDT?",
      "p4": "Toque el ícono en la parte superior derecha de la página de inicio de XWallet, busque \"Configuración del comerciante\" y active la liquidación de USDT.",
      "imgAlt1": "USDT recaudación",
      "imgAlt2": "USDT recaudación activada"
    },
    "sect4": {
      "title": "4. ¿Cómo consultar el “historial de recibos”?",
      "p1": "Vaya a \"Recibir\" y busque \"Historial de recibos\", puede ver todas las entradas para las transacciones de hoy y anteriores.",
      "imgAlt": "Historial de recibos"
    },
    "sect5": {
      "title": "5.¿Cómo emitir un reembolso?",
      "p1": "Para emitir un reembolso, vaya a \"Historial de recibos\", busque la transacción en particular que requiere una cancelación y luego tóquela para realizar un reembolso.",
      "p2": "Nota: el reembolso solo se puede realizar dentro de los 30 minutos posteriores a la finalización de la transacción. Las solicitudes de reembolso después de 30 minutos no son reembolsables del sistema.",
      "imgAlt1": "Encontrar trasacción de reembolso",
      "imgAlt2": "Detalles de reembolso con exito"
    },
    "sect6": {
      "title": "6. ¿Cómo retirar USDT como comerciante de XWallet?",
      "p1": "Abrir la aplicación Xwallet y seleccionar \"Tarjeta\"",
      "p2": "Ir a USDT ajustes y pulsar sobre “Transferir”",
      "p3": "Ingrese la dirección del destinatario (dirección de retiro) y la cantidad a transferencia",
      "p4": "Comprueba y confirma la información sea correcta.",
      "p5": "Entonces proceder con la transferencia.",
      "p6": "Espere el resultado final de la transacción, ya que todas las transacciones deben transmitirse y actualizarse en la red de blockchain.",
      "imgAlt1": "Cuenta USDT",
      "imgAlt2": "Retirar USDT"
    }
  },
  "faq": {
    "title": "Preguntas más frecuentes",
    "subTitle": "XWallet de Pundi X",
    "faqArr": {
      "0": {
        "title": "1. ¿Qué es XWallet?",
        "text": {"0": "XWallet es una aplicación de billetera de activos digitales móviles que admite la gestión del saldo de sus tarjetas XPASS, el pago de escaneo de códigos fuera de línea y el pago de aplicaciones móviles."}
      },
      "1": {
        "title": "2. ¿Cómo consigo la aplicación XWallet? ¿Cuál es el requisito básico para ejecutar XWallet?",
        "text": {"0": "Descargue la aplicación XWallet del sitio web oficial de Pundi X en https://www.pundix.com, o descárguela de Google Play Store. XWallet se ejecuta en Android 4.4 y superior; Sistema iOS 10.0 y superior"}
      },
      "2": {
        "title": "3. ¿Puedo usar la aplicación XWallet para pagar sin vincularme a ninguna tarjeta XPASS?",
        "text": {"0": "Sí, puedes usarlo como una aplicación de pago independiente."}
      },
      "3": {
        "title": "4. ¿Cómo puedo recargar la XWallet?",
        "text": {
          "0": "Para recargar su saldo de XWallet, puede transferir fondos de otras direcciones de billetera de activos digitales a su XWallet.",
          "1": "Si tiene una tarjeta XPASS, también puede agregarla a la aplicación XWallet."
        }
      },
      "4": {
        "title": "5. ¿Cómo recargar la tarjeta XPASS usando XWallet?",
        "text": {
          "0": "El saldo de su XWallet se puede transferir a la dirección del activo vinculada a su tarjeta XPASS:",
          "1": "1. Seleccione el tipo de moneda que desea recargar",
          "2": "2. Copie la dirección de recarga o escanee el código QR de recarga",
          "3": "3. Use la otra billetera (con el tipo correcto de criptomoneda) para hacer la transferencia"
        }
      },
      "5": {
        "title": "6. ¿Cómo acepto monedas de otras carteras en XWallet?",
        "text": {"0": "Seleccione el tipo de moneda admitida por XWallet y use la función de transferencia de otras carteras para completar la dirección correspondiente de su XWallet."}
      },
      "6": {
        "title": "7. ¿La XWallet comparte la misma dirección que la tarjeta XPASS?",
        "text": {"0": "No. Cada tarjeta XPASS tiene su propia dirección única que es diferente de la dirección XWallet. Su XWallet contendrá su propia dirección única."}
      },
      "7": {
        "title": "8. ¿Qué monedas son compatibles con XWallet?",
        "text": {"0": "La edición de lanzamiento contará con el apoyo de cuatro monedas: Bitcoin, Ethereum, BNB y NPXS. Pronto habrá una actualización que ampliará enormemente el rango de monedas admitidas."}
      },
      "8": {
        "title": "9. ¿Cómo configuro la contraseña para mi XWallet?",
        "text": {"0": "Al registrar su XWallet, se le solicitará que configure su contraseña de inicio de sesión y la contraseña de pago. También puede cambiar la contraseña en la configuración de XWallet."}
      },
      "9": {
        "title": "10. ¿Qué hago si olvido mi contraseña de XWallet?",
        "text": {"0": "Puede recuperar su contraseña en la configuración de XWallet u obtener ayuda contactando a nuestro servicio de atención al cliente en XWallet [at] pundix.com."}
      },
      "10": {
        "title": "11. ¿Cómo puedo hacer una copia de seguridad de mis datos de XWallet?",
        "text": {"0": "La XWallet no es una billetera fría, por lo que no hay necesidad de una copia de seguridad."}
      },
      "11": {
        "title": "12. ¿Puedo agregar la tarjeta XPASS a la aplicación XWallet en otro teléfono / dispositivo?",
        "text": {"0": "Una vez que su tarjeta XPASS esté vinculada a su aplicación XWallet, puede recuperar los datos de su tarjeta XPASS en cualquier teléfono o dispositivo a través de la aplicación XWallet."}
      },
      "12": {
        "title": "13. ¿Qué debo hacer si me roban los activos digitales de mi XWallet?",
        "text": {"0": "Garantizar la seguridad en la aplicación XWallet es de suma importancia para nosotros. Si algún activo digital desaparece o es robado de su XWallet, envíe un correo electrónico a xwallet [at] pundix.com inmediatamente con su correo electrónico registrado. Investigaremos y tomaremos medidas de inmediato para asegurarnos de que sus fondos se mantengan seguros."}
      },
      "13": {
        "title": "14. ¿Admite XWallet la distribución de token desbloqueada mensual de NPXS?",
        "text": {"0": "Si lo hace"}
      },
      "14": {
        "title": "15. ¿Tendré una clave privada al configurar una cuenta en la aplicación XWallet?",
        "text": {"0": "No. Se requieren su dirección de correo electrónico y número de teléfono móvil para configurar una cuenta de aplicación XWallet."}
      }
    },
    "other": "¿No encontraste las respuestas a tus preguntas? Puede encontrar más preguntas frecuentes sobre XWallet aquí."
  }
}